var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 14.502v0a4.603 4.603 0 01-2.264-6.163l.238-.502 2.386-4.429a1.131 1.131 0 012.03 0l3.076 6.233c.165.334.483.566.852.62l6.878.999a1.131 1.131 0 01.628 1.93l-4.978 4.852c-.267.26-.325 1.001-.325 1.001l.587 3.426.588 3.425a1.131 1.131 0 01-1.642 1.193l-6.153-3.235a1.131 1.131 0 00-1.053 0l-6.152 3.235c-.83.436-1.8-.268-1.642-1.193l1.175-6.85a1.131 1.131 0 00-.325-1.002L2.55 13.19a1.132 1.132 0 01.627-1.93l2.951-.5 1.476-.25",
    stroke: "#E03D5C",
    strokeWidth: 1.875
  })));
}
export default SvgStar;